import { Stack, Text } from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { IdentityType } from '@blockpulse3/graphql/hooks';
import { CardIdentity } from '@blockpulse3/ui/commons';

import { draftAgentTitle } from '../../../../../OtherRoleForm';
import { representantTitle } from '../../../Forms/RepresentantInformationsForm';
import { shareholderTitle } from '../../../Forms/ShareholderInformationsForm';
import { useSPVForm } from '../../../provider';

type Props = unknown;

/**
 * SummaryRoleInfos.
 * Summary of the role for the SPV funnel.
 *
 * @returns {JSX.Element}
 */
export function SummaryRoleInfos(): JSX.Element {
  const i18nRoleValues = useTranslations('RoleValues');
  const i18nSummaryRoleInfos = useTranslations('SPVSummaryRoleInfos');

  const { companyDraftContent } = useSPVForm();
  const { representatives, agents, initialShareholder } = companyDraftContent;

  return (
    <Stack spacing="4">
      <Text fontSize="xl" fontWeight="bold">
        {i18nSummaryRoleInfos('Title')}
      </Text>
      {representatives.map((rep) => (
        <CardIdentity
          key={rep.name + rep.firstName + rep.lastName}
          subTitle={representantTitle(rep)}
          title={i18nRoleValues(rep.role as keyof IntlMessages['RoleValues'])}
          type={rep.type as IdentityType}
        />
      ))}
      {agents.map((agent) => (
        <CardIdentity
          key={agent.firstName + agent.lastName}
          subTitle={draftAgentTitle(agent)}
          title={i18nRoleValues(agent.role as keyof IntlMessages['RoleValues'])}
          type={IdentityType.INDIVIDUAL}
        />
      ))}
      <CardIdentity
        subTitle={shareholderTitle(initialShareholder)}
        title={i18nRoleValues('Shareholder')}
        type={initialShareholder.type as IdentityType}
      />
    </Stack>
  );
}

export type SummaryRoleInfosProps = Props;
